// components/QueueFilters.jsx
import React from 'react';
import { districts } from '../constants/queueConstants';
import '../StatisticaQueue.css';

const QueueFilters = ({
    selDist,
    period,
    periods,
    onDistrictChange,
    onPeriodChange,
    onShowData
}) => {
    return (
        <div className="filter-row">
            <div className="row">
                <div className="col-md-3 filter-section">
                    <label className="filter-label">Район:</label>
                    <select 
                        className="filter-select" 
                        value={selDist} 
                        onChange={onDistrictChange}
                    >
                        {districts.map((dist) => (
                            <option key={dist} value={dist}>{dist}</option>
                        ))}
                        <option value='all'>всі райони</option>
                    </select>
                </div>

                <div className="col-md-3 filter-section">
                    <label className="filter-label">Станом на:</label>
                    <select 
                        className="filter-select" 
                        value={period} 
                        onChange={onPeriodChange}
                    >
                        {periods.map(p => (
                            <option key={p} value={p}>{p}</option>
                        ))}
                    </select>
                </div>
                
                <div className="col-md-3 filter-section">
                    <label className="filter-label">&nbsp;</label>
                    <button className="filter-button" onClick={onShowData}>
                        Показати
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QueueFilters;